<div class="mat-typography dialog-container layout-column">
  <h1 mat-dialog-title>
    <span>Cancellazione </span>
    <span [ngSwitch]="data?.itemType">
      <span *ngSwitchCase="CD_TYPE.TASK">task</span>
      <span *ngSwitchCase="CD_TYPE.REMINDER">esame</span>
      <span *ngSwitchDefault></span>
    </span>
  </h1>

  <mat-dialog-content>
    <p [ngSwitch]="data?.itemType">
      <span *ngSwitchCase="CD_TYPE.TASK"
        >Sei veramente sicura/o di voler cancellare questo task?</span
      >
      <span *ngSwitchCase="CD_TYPE.REMINDER"
        >Sei veramente sicura/o di voler cancellare questo esame?</span
      >
      <span *ngSwitchDefault></span>
    </p>
  </mat-dialog-content>

  <mat-dialog-actions>
    <div class="layout-row justify-end items-center gap-12 flex-fill">
      <button mat-button [mat-dialog-close]="false">No</button>
      <button mat-button color="warn" [mat-dialog-close]="true">Sì</button>
    </div>
  </mat-dialog-actions>
</div>
